// Shared date-formatting helpers used across pages.
// All take a YYYY-MM-DD string and render a human, Anglophone format.

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const parseYmd = (dateStr) => {
  if (!dateStr) return null;
  // Accept "YYYY-MM-DD" (preferred) or full ISO strings
  const ymd = /^\d{4}-\d{2}-\d{2}/.test(dateStr) ? dateStr.slice(0, 10) : dateStr;
  const [y, m, d] = ymd.split('-').map(Number);
  if (!y || !m || !d) return null;
  // Use local midnight to avoid timezone shift on weekday
  return new Date(y, m - 1, d);
};

// "Monday, 28 April 2026"
export const formatDateLong = (dateStr) => {
  const d = parseYmd(dateStr);
  if (!d) return dateStr || '';
  return `${DAYS[d.getDay()]}, ${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

// "Mon, 28 April 2026" — compact in tables / inline
export const formatDateShort = (dateStr) => {
  const d = parseYmd(dateStr);
  if (!d) return dateStr || '';
  return `${DAYS[d.getDay()].slice(0, 3)}, ${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

// Day name only: "Tuesday"
export const formatDayName = (dateStr) => {
  const d = parseYmd(dateStr);
  if (!d) return '';
  return DAYS[d.getDay()];
};
